// Natureza do processo (clients.type), com rota pública da listagem e do detalhe.
const data = [
    {
        id: 1,
        name: 'Recuperação judicial',
        plural: 'Recuperações judiciais',
        route: '/recuperacao-judicial'
    },
    {
        id: 5,
        name: 'Recuperação extrajudicial',
        plural: 'Recuperações extrajudiciais',
        route: '/recuperacao-extrajudicial'
    },
    { id: 2, name: 'Falência', plural: 'Falências', route: '/falencia' }
];

export const getCaseType = (type) => data.find((item) => item.id === Number(type)) || data[0];

export default [...data];
